import React, { useState } from "react";

const JudicialElectionButton = () => {
  const buttonData = [
    {
      id: 1,
      title: "Sistema de Candidatos y Candidatas Conóceles",
      url: "http://conocelestlaxcala.org.mx/",
      image: "https://itetlax.org.mx/assets/img/icons/LOGO_BLANCO.png",
      hasGif: false,
    },
    {
      id: 2,
      title: "Versión Ejecutiva del Sistema Candidatos y Candidatas Conóceles",
      url: "https://conocelesversionejecutiva.itetlax.org.mx/",
      image: "https://itetlax.org.mx/assets/img/icons/LOGO_BLANCO.png",
      hasGif: false,
    },
    {
      id: 3,
      title: "Información Elección Judicial Local 2025",
      url: "https://pelepj-2025.itetlax.org.mx/",
      image: "https://itetlax.org.mx/assets/img/icons/ELECTION.gif",
      hasGif: true,
    },
  ];

  return (
    <div className="col-12 mb-5">
      {/* Botones existentes - Comentados */}
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "stretch",
          flexWrap: "wrap",
          gap: "20px",
          marginBottom: "20px",
          "@media (max-width: 768px)": {
            flexDirection: "column",
            gap: "15px",
          },
        }}
      >
        {buttonData.map((button) => (
          <SingleButton
            key={button.id}
            title={button.title}
            url={button.url}
            image={button.image}
            hasGif={button.hasGif}
            gifUrl={button.hasGif ? button.image : null}
          />
        ))}
      </div> */}

      {/* Botón "Sitio de publicación" con GIF más grande */}
      <SingleButton
        title="Sitio de Publicación de Resultados de Cómputos"
        url="https://www.computospj2025-tlax.org.mx/"
        image="https://itetlax.org.mx/assets/img/icons/LOGO_BLANCO.png"
        hasGif={true}
        gifUrl="https://itetlax.org.mx/assets/img/icons/article.gif"
        fullWidth={true}
        compact={true}
        customGifStyle={{ height: "50px" }}
      />
    </div>
  );
};

const SingleButton = ({
  title,
  url,
  image,
  hasGif,
  fullWidth = false,
  compact = false,
  gifUrl,
  customGifStyle = {},
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    window.open(url, "_blank");
  };

  return (
    <div
      style={{
        flex: fullWidth ? "1 1 100%" : "1",
        minWidth: fullWidth ? "100%" : "250px",
        display: "flex",
        height: compact
          ? "80px"
          : fullWidth
          ? "clamp(100px, 15vw, 180px)"
          : "clamp(150px, 20vw, 220px)",
      }}
    >
      <button
        style={{
          width: "100%",
          padding: compact ? "10px 15px" : "15px",
          fontSize: compact ? "18px" : fullWidth ? "20px" : "17px",
          fontWeight: "900",
          color: "#ffffff",
          background: isHovered
            ? "linear-gradient(135deg, rgba(168, 83, 148, 0.9), rgba(167, 0, 130, 0.9))"
            : "linear-gradient(135deg, #9e0876, #760564)",
          border: "none",
          borderRadius: "8px",
          boxShadow: isHovered
            ? "0 8px 15px rgba(160, 8, 119, 0.3)"
            : "0 4px 10px rgba(0, 0, 0, 0.1)",
          cursor: "pointer",
          transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
          letterSpacing: "0.8px",
          position: "relative",
          overflow: "hidden",
          transform: isActive ? "scale(0.98)" : "scale(1)",
          zIndex: "1",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onMouseDown={() => setIsActive(true)}
        onMouseUp={() => setIsActive(false)}
        onClick={handleClick}
      >
        <span
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)",
            transform: isHovered ? "translateX(100%)" : "translateX(-100%)",
            transition: "transform 0.5s ease-in-out",
            zIndex: -1,
          }}
        />

        <div
          style={{
            textAlign: "center",
            textShadow: "0 1px 3px rgba(0, 0, 0, 0.5)",
            zIndex: 1,
            marginBottom: fullWidth || compact ? "0" : "10px",
            lineHeight: "1.3",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {title}
          {/* Mostrar GIF en el título solo si es fullWidth o compact */}
          {(fullWidth || compact) && hasGif && gifUrl && (
            <img
              src={gifUrl}
              alt=""
              style={{
                height: "40px",
                width: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))",
                transition: "transform 0.3s ease",
                transform: isHovered ? "scale(1.1)" : "scale(1)",
                ...customGifStyle,
              }}
            />
          )}
        </div>

        {!fullWidth && !compact && (
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              maxHeight: "60%",
            }}
          >
            <img
              src={image}
              alt="Icono"
              style={{
                height: hasGif
                  ? "clamp(80px, 12vw, 120px)"
                  : "clamp(70px, 10vw, 100px)",
                width: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))",
                transition: "transform 0.3s ease",
                transform: isHovered ? "scale(1.05)" : "scale(1)",
              }}
            />
          </div>
        )}
      </button>
    </div>
  );
};
export default JudicialElectionButton;